import { Key } from "@avvoka/shared"

export const enum ValidationErrorSeverity {
  Warning = 'warning',
  Error = 'error'
}

type ValidationError = [ValidationErrorSeverity, string]

export type ValidationResult = ValidationError | undefined | null

export const NUMBER_CHARACTERS = [
  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'
]

const NUMBER_LIKE_CHARACTERS = [
  ...NUMBER_CHARACTERS, '-', '.'
]

const CONTROL_LIKE_CHARACTERS = [
  Key.Backspace, Key.Delete, Key.ArrowUp, Key.ArrowDown, Key.ArrowLeft, Key.Tab,
  Key.ArrowRight, Key.Enter, Key.NumpadEnter, Key.ShiftLeft, Key.ShiftRight, Key.Escape,
  Key.F1, Key.F2, Key.F3, Key.F4, Key.F5, Key.F6, Key.F7, Key.F8, Key.F9, Key.F10, Key.F11, Key.F12
]

export function isNullOrUndefined<T>(value: T | undefined | null): value is undefined | null {
  return typeof value === 'undefined' || value === null
}

export function isNumberLikeCharacter(key: string | Key) {
  return NUMBER_LIKE_CHARACTERS.includes(key)
}

export function isNumberCharacter(key: string | Key) {
  return NUMBER_CHARACTERS.includes(key)
}

export function isControlCharacter(key: string | Key) {
  return CONTROL_LIKE_CHARACTERS.includes(key as Key)
}
